<template>
	<div>
	<v-app-bar dark color="secondary" app flat clipped-left>
		<v-toolbar-title class="text--white">
			<img src="/static/images/logo.png" width="20" height="20" class="mr-2"/>
			Menu-QR Gestor
		</v-toolbar-title>
			<v-spacer></v-spacer>
			<div v-if="$vuetify.breakpoint.mdAndUp">
				<v-btn class="mr-2"  color="secondary" @click="goCategories" v-if="$store.state.categoryModule.showBtnToolbar"> 
					<v-icon left>mdi-transfer-left</v-icon> CATEGORÍAS
				</v-btn>
				<v-btn class="mr-2"  color="secondary" :href="`https://menu-qr.web.app/i/${$store.state.businessModule.business.id}`" target="_blank" >
					<v-icon left>mdi-eye</v-icon> Ver App
				</v-btn>
				<v-btn class="mr-2" color="secondary" @click="editCustomer">
					<v-icon left>mdi-account</v-icon> Usuario
				</v-btn>
				<v-btn class="mr-2" color="secondary" @click="editBusiness">
					<v-icon left>mdi-garage-variant</v-icon> Negocio
				</v-btn>
				<v-btn class="mr-3" @click="logOut" color="secondary">
					<v-icon left class="mr-2">mdi-exit-to-app</v-icon> SALIR
				</v-btn>
		</div>
		<v-app-bar-nav-icon color="white"  @click.stop="drawer = !drawer" v-else />
	</v-app-bar>

	<v-navigation-drawer v-model="drawer" app temporary right color="secondary">

			<v-btn class="mr-2" block color="secondary" @click="goCategories" v-if="$store.state.categoryModule.showBtnToolbar"> 
				<v-icon left>mdi-transfer-left</v-icon> CATEGORÍAS
			</v-btn>
			<v-divider/>
			<v-btn class="mr-2" block color="secondary" :href="`https://menu-qr.web.app/i/${$store.state.businessModule.business.id}`" target="_blank" >
				<v-icon left>mdi-eye</v-icon> Ver App
			</v-btn>
			<v-divider/>
			<v-btn class="mr-2" block color="secondary" @click="editCustomer">
				<v-icon left>mdi-account</v-icon> Usuario
			</v-btn>
			<v-divider/>
			<v-btn class="mr-2" block color="secondary" @click="editBusiness">
				<v-icon left>mdi-garage-variant</v-icon> Negocio
			</v-btn>
			<v-divider/>
			<v-btn class="mr-3" @click="logOut" block color="secondary">
				<v-icon left class="mr-2">mdi-exit-to-app</v-icon> SALIR
			</v-btn>

	</v-navigation-drawer>

	</div>
</template>

<script>
	import { mapActions } from 'vuex';
	import navigationMixin from '@/mixins/navigation';
	export default {
		data: () => ({
			drawer:null,
			permanente: true,
			items: [
        { icon: 'mdi-transfer-left', text: 'CATEGORÍAS', to: 'goCategories' },
				{ divider: true },
			],
		}),
		methods: {
			...mapActions('authModule',['logOut']),

			goCategories(){
				this.$store.commit('categoryModule/SET_SHOW_DATATABLE', true, {root: true})
				this.$store.commit('categoryModule/SET_SHOW_BTN_TOOLBAR', false, {root: true})
				this.$store.commit('customerModule/SET_SHOW_COMPONENT', false, {root: true})
				this.$store.commit('itemModule/SET_SHOW_COMPONENT', false, {root: true})
				this.drawer = false
				this.$router.push({name: 'CustomerDashboard',})
			},
			editCustomer(){
				this.$router.push({
					name: 'CustomerUser',
					params: {
						cutomr: this.$store.state.userModule.user
					}
				}) 

				// this.$store.commit('customerModule/SET_CUSTOMER', this.$store.state.userModule.user, {root: true})
				// this.$store.commit('categoryModule/SET_SHOW_DATATABLE', false, {root: false})
				// this.$store.commit('businessModule/SET_SHOW_COMPONENT', false, {root: false})
				// this.$store.commit('customerModule/SET_SHOW_COMPONENT', true, {root: true})
				// this.$store.commit('itemModule/SET_SHOW_COMPONENT', false, {root: true})
				this.drawer = false
			},
			editBusiness(){
				this.$router.push({
					name: 'CustomerBusiness',
					params: {
						buss: this.$store.state.businessModule.business
					}
				}) 
				// this.$store.commit('categoryModule/SET_SHOW_BTN_TOOLBAR', true, {root: true})
				// this.$store.commit('categoryModule/SET_SHOW_DATATABLE', false, {root: false})
				// this.$store.commit('businessModule/SET_SHOW_COMPONENT', true, {root: false})
				// this.$store.commit('customerModule/SET_SHOW_COMPONENT', false, {root: true})
				// this.$store.commit('itemModule/SET_SHOW_COMPONENT', false, {root: true})
				// this.drawer = false
			},
			logOff(){
				
			}

		}
	}
</script>
